window.LKHHH_CAMP_PHOTO_URL = "https://cdn.shopify.com/s/files/1/0692/7686/0727/files/IND_2774.jpg?v=1717385472";

window.LKHHH_ABOUT_PAGE_URL = "/pages/about";

window.LKHHH_HARE_IMAGE_SLOTS = window.LKHHH_HARE_IMAGE_SLOTS || [];
window.LKHHH_RUN_IMAGE_SLOTS = window.LKHHH_RUN_IMAGE_SLOTS || [];

(function(){
  const FIRESTORE_PROJECT = "lkhhh-run-production";
  const FIRESTORE_API_KEY = "AIzaSyCJbBG6Gsxl5-kzU3eRzbBqfbA6sjr-XXw";
  const FIRESTORE_DOCUMENTS_API = "https://firestore.googleapis.com/v1/projects/" + FIRESTORE_PROJECT + "/databases/(default)/documents";
  const DEFAULT_POSKO_MAP = "https://maps.app.goo.gl/JijQd9Q8ZZ8mjkmD7?g_st=ic";
  const DEFAULT_CAMP_MAP = "https://maps.app.goo.gl/7cgNZ2dGLVKiD1Rw9";
  const LKHHH_ICS_URL = "https://script.google.com/macros/s/AKfycbylyNJYx2j0cwUohTOSkVqHUovAg7qSSzmYRUY9CUhBQA1QJKwI0MunseEgRhyu9vkFQg/exec?action=ical&v=20260616";

  const topbar = document.querySelector("#lkhhh-page .lkhhh-topbar");
  if(topbar){
    const burger = topbar.querySelector(".lkhhh-burger");
    const menu = topbar.querySelector(".lkhhh-mini-menu");
    if(burger && menu){
      burger.addEventListener("click", function(e){
        e.stopPropagation();
        const isOpen = topbar.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
      menu.querySelectorAll("a").forEach(function(link){
        link.addEventListener("click", function(){
          topbar.classList.remove("is-open");
          burger.setAttribute("aria-expanded", "false");
        });
      });
      document.addEventListener("click", function(e){
        if(!topbar.contains(e.target)){
          topbar.classList.remove("is-open");
          burger.setAttribute("aria-expanded", "false");
        }
      });
    }
  }

  const calendarModal = document.getElementById("lkhhhGoogleCalendarModal");
  const openCalendarModalBtn = document.getElementById("openGoogleCalendarModal");
  const closeCalendarModalBtn = document.getElementById("closeGoogleCalendarModal");
  const copyBtn = document.getElementById("modalCopyCalendarUrl");
  const selectBtn = document.getElementById("selectIcsBtn");
  const icsInput = document.getElementById("icsUrlInput");
  const copyStatus = document.getElementById("lkhhhCalendarCopyStatus");

  function openCalendarModal(){
    if(!calendarModal) return;
    if(icsInput) icsInput.value = LKHHH_ICS_URL;
    calendarModal.classList.add("is-open");
    calendarModal.setAttribute("aria-hidden", "false");
  }

  function closeCalendarModal(){
    if(!calendarModal) return;
    calendarModal.classList.remove("is-open");
    calendarModal.setAttribute("aria-hidden", "true");
  }

  function selectCalendarInput(){
    if(!icsInput) return;
    icsInput.value = LKHHH_ICS_URL;
    icsInput.focus();
    icsInput.select();
    icsInput.setSelectionRange(0, icsInput.value.length);
  }

  function fallbackCopyText(){
    selectCalendarInput();
    let copied = false;
    try{ copied = document.execCommand("copy"); }catch(e){ copied = false; }
    return copied;
  }

  if(openCalendarModalBtn) openCalendarModalBtn.addEventListener("click", openCalendarModal);
  if(closeCalendarModalBtn) closeCalendarModalBtn.addEventListener("click", closeCalendarModal);
  if(calendarModal){
    calendarModal.addEventListener("click", function(e){
      if(e.target === calendarModal) closeCalendarModal();
    });
  }
  document.addEventListener("keydown", function(e){
    if(e.key === "Escape") closeCalendarModal();
  });
  if(icsInput){
    icsInput.value = LKHHH_ICS_URL;
    icsInput.addEventListener("click", function(){ selectCalendarInput(); });
  }
  if(selectBtn){
    selectBtn.addEventListener("click", function(){
      selectCalendarInput();
      if(copyStatus){
        copyStatus.innerHTML = (window.LKHHH_T_STATUS && window.LKHHH_T_STATUS("selected")) || "URL selected. Press Command + C, or tap Copy on mobile.";
      }
    });
  }
  if(copyBtn && icsInput){
    copyBtn.addEventListener("click", function(){
      icsInput.value = LKHHH_ICS_URL;
      const originalText = copyBtn.textContent;
      function showCopied(){
        copyBtn.textContent = "Copied";
        if(copyStatus){
          copyStatus.innerHTML = (window.LKHHH_T_STATUS && window.LKHHH_T_STATUS("copied")) || "✅ Calendar URL copied. Now click Open Google Calendar and paste it.";
        }
        setTimeout(function(){ copyBtn.textContent = originalText; }, 1800);
      }
      function showManual(){
        selectCalendarInput();
        copyBtn.textContent = "URL Selected";
        if(copyStatus){
          copyStatus.innerHTML = (window.LKHHH_T_STATUS && window.LKHHH_T_STATUS("blocked")) || "⚠️ Browser blocked automatic copy. The URL is selected. Press Command + C, or tap Copy on mobile.";
        }
        setTimeout(function(){ copyBtn.textContent = originalText; }, 2200);
      }
      if(navigator.clipboard && window.isSecureContext){
        navigator.clipboard.writeText(LKHHH_ICS_URL).then(showCopied).catch(function(){
          const copied = fallbackCopyText();
          copied ? showCopied() : showManual();
        });
      }else{
        const copied = fallbackCopyText();
        copied ? showCopied() : showManual();
      }
    });
  }

  function parseDate(text){
    if(!text) return null;
    const cleaned = String(text).trim();
    let d = new Date(cleaned);
    if(!isNaN(d.getTime())) return d;
    let m = cleaned.match(/^(\d{1,2})[-\/ ]([A-Za-z]{3,})[-\/ ](\d{4})$/);
    if(m){
      const months = {jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11};
      const month = months[m[2].slice(0,3).toLowerCase()];
      if(month !== undefined) return new Date(Number(m[3]), month, Number(m[1]));
    }
    m = cleaned.match(/^(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})$/);
    if(m) return new Date(Number(m[1]), Number(m[2])-1, Number(m[3]));
    return null;
  }

  function sameOrFuture(date){
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return date >= today;
  }

  function isHidden(status){
    const s = String(status || "").toLowerCase();
    return s === "hidden" || s === "batal" || s === "cancelled" || s === "canceled";
  }

  function joinNames(a,b){
    return [a,b].map(function(v){ return String(v || "").trim(); }).filter(Boolean).join(" & ");
  }

  function getRunHareLabel(row){
    const names = joinNames(row && row.hare, row && row.coHare);
    if(names) return names;
    const eventType = String(row && (row.eventType || row.title) || "").trim();
    return eventType && eventType.toLowerCase() !== "regular run" ? eventType : "Committee Run";
  }

  function decodeFirestoreValue(value){
    if(!value || typeof value !== "object") return null;
    if("nullValue" in value) return null;
    if("stringValue" in value) return value.stringValue;
    if("booleanValue" in value) return value.booleanValue;
    if("integerValue" in value) return Number(value.integerValue);
    if("doubleValue" in value) return Number(value.doubleValue);
    if("timestampValue" in value) return value.timestampValue;
    if("arrayValue" in value){
      return (value.arrayValue.values || []).map(decodeFirestoreValue);
    }
    if("mapValue" in value){
      return decodeFirestoreFields(value.mapValue.fields || {});
    }
    return null;
  }

  function decodeFirestoreFields(fields){
    return Object.keys(fields || {}).reduce(function(result,key){
      result[key] = decodeFirestoreValue(fields[key]);
      return result;
    },{});
  }

  function decodeFirestoreDocument(document){
    if(!document || !document.fields) return null;
    return decodeFirestoreFields(document.fields);
  }

  function firestoreUrl(path){
    return FIRESTORE_DOCUMENTS_API + "/" + path + "?key=" + encodeURIComponent(FIRESTORE_API_KEY);
  }

  function fetchFirestoreDocument(path){
    return fetch(firestoreUrl(path), {cache:"no-store"}).then(function(response){
      if(!response.ok) throw new Error("Firestore document unavailable");
      return response.json();
    }).then(decodeFirestoreDocument);
  }

  function normalizeFirestoreRun(run){
    const hareNames = []
      .concat(Array.isArray(run.hareNames) ? run.hareNames : [])
      .concat(Array.isArray(run.coHareNames) ? run.coHareNames : [])
      .map(function(name){ return String(name || "").trim(); })
      .filter(Boolean);
    return Object.assign({}, run, {
      run: String(run.runId || run.run || ""),
      date: String(run.dateKey || run.date || ""),
      hare: hareNames.join(", "),
      coHare: "",
      eventType: String(run.eventType || run.title || "Regular Run"),
      time: String(run.time || run.startTime || "07.30 WIB"),
      location: String(run.location || "New Posko LKHHH"),
      mapsUrl: String(run.mapsUrl || run.googleMapsUrl || "")
    });
  }

  function fetchFirestoreSchedule(){
    return fetchFirestoreDocument("settings/currentRun").then(function(setting){
      const runId = String(setting && setting.runId || "").trim();
      if(!/^\d{1,8}$/.test(runId)) throw new Error("Current run unavailable");
      return fetchFirestoreDocument("runs/run-" + encodeURIComponent(runId)).then(function(current){
        if(!current) throw new Error("Current run document unavailable");
        const currentRun = normalizeFirestoreRun(current);
        const request = {
          structuredQuery:{
            from:[{collectionId:"runs"}],
            where:{compositeFilter:{op:"AND",filters:[
              {fieldFilter:{field:{fieldPath:"status"},op:"EQUAL",value:{stringValue:"Active"}}},
              {fieldFilter:{field:{fieldPath:"dateKey"},op:"GREATER_THAN",value:{stringValue:currentRun.date}}}
            ]}},
            orderBy:[{field:{fieldPath:"dateKey"},direction:"ASCENDING"}],
            limit:4
          }
        };
        return fetch(FIRESTORE_DOCUMENTS_API + ":runQuery?key=" + encodeURIComponent(FIRESTORE_API_KEY), {
          method:"POST",
          headers:{"Content-Type":"application/json"},
          cache:"no-store",
          body:JSON.stringify(request)
        }).then(function(response){
          if(!response.ok) throw new Error("Firestore schedule unavailable");
          return response.json();
        }).then(function(rows){
          const upcoming = (Array.isArray(rows) ? rows : [])
            .map(function(item){ return decodeFirestoreDocument(item.document); })
            .filter(Boolean)
            .map(normalizeFirestoreRun);
          return {current:currentRun, schedule:[currentRun].concat(upcoming)};
        });
      });
    });
  }

  function setText(id,value){
    const el = document.getElementById(id);
    if(el) el.textContent = value || "";
  }

  function escapeHtml(value){
    return String(value || "")
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;")
      .replace(/'/g,"&#039;");
  }

  function escapeAttr(value){
    return escapeHtml(value).replace(/`/g,"&#096;");
  }

  function normalizeImageUrl(url){
    const u = String(url || "").trim();
    if(!u) return "";
    return u.indexOf("//") === 0 ? "https:" + u : u;
  }

  function getJakartaTodayDateOnly(){
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone:"Asia/Jakarta",
      year:"numeric",
      month:"2-digit",
      day:"2-digit"
    }).format(new Date()).split("-");
    return new Date(Number(parts[0]), Number(parts[1])-1, Number(parts[2]));
  }

  function getMondayBeforeExpiredDate(expiredDate){
    const s = new Date(expiredDate);
    const day = s.getDay();
    const back = day === 0 ? 6 : day - 1;
    s.setDate(s.getDate() - back);
    s.setHours(0,0,0,0);
    return s;
  }

  function firstImageFromObject(obj){
    if(!obj) return "";
    const possibleFields = [
      "imageUrl","imageURL","image","posterUrl","posterURL","posterImageUrl","posterImageURL","posterImage",
      "hareImageUrl","hareImageURL","hareImage","heroImageUrl","heroImageURL","heroImage",
      "previewImageUrl","previewImageURL","previewImage","whatsappImageUrl","whatsappImageURL","whatsappImage",
      "metadataImageUrl","metadataImageURL","metadataImage","metaImageUrl","metaImageURL","metaImage",
      "ogImageUrl","ogImageURL","ogImage","photoUrl","photoURL","photo","pictureUrl","pictureURL","picture",
      "thumbnailUrl","thumbnailURL","thumbnail"
    ];
    for(let i=0;i<possibleFields.length;i++){
      const value = obj[possibleFields[i]];
      if(value) return normalizeImageUrl(value);
    }
    const metadata = obj.metadata || obj.meta || obj.Metadata || obj.META;
    if(metadata){
      if(typeof metadata === "string"){
        try{
          const parsed = JSON.parse(metadata);
          const found = firstImageFromObject(parsed);
          if(found) return found;
        }catch(e){}
      }else if(typeof metadata === "object"){
        const found = firstImageFromObject(metadata);
        if(found) return found;
      }
    }
    return "";
  }

  function isImageExpiredFromRow(row){
    const exp = row.imageExpiredDate || row.imageExpiryDate || row.imageExpires || row.posterExpiredDate || row.posterExpiryDate || row.posterExpires || row.expiredDate;
    if(!exp) return false;
    const d = parseDate(exp);
    if(!d) return false;
    d.setHours(23,59,59,999);
    return d < getJakartaTodayDateOnly();
  }

  function getActiveSlotImage(row){
    const hareSlots = window.LKHHH_HARE_IMAGE_SLOTS || [];
    const runSlots = window.LKHHH_RUN_IMAGE_SLOTS || [];
    const today = getJakartaTodayDateOnly();
    const run = String(row.run || "").trim();
    const date = String(row.date || "").trim();

    for(let i=0;i<hareSlots.length;i++){
      const slot = hareSlots[i] || {};
      const url = normalizeImageUrl(slot.url || slot.image || slot.imageUrl);
      const expiredDate = parseDate(slot.expiredDate || slot.expires || slot.expiryDate);
      if(!url || !expiredDate) continue;
      expiredDate.setHours(23,59,59,999);
      const startDate = getMondayBeforeExpiredDate(expiredDate);
      if(today >= startDate && today <= expiredDate) return url;
    }

    for(let j=0;j<runSlots.length;j++){
      const slot = runSlots[j] || {};
      const url = normalizeImageUrl(slot.url || slot.image || slot.imageUrl);
      if(!url) continue;
      const exp = parseDate(slot.expiredDate || slot.expires || slot.expiryDate);
      if(exp){
        exp.setHours(23,59,59,999);
        if(exp < today) continue;
      }
      const slotRun = String(slot.run || "").trim();
      const slotDate = String(slot.date || "").trim();
      if((slotRun && slotRun === run) || (slotDate && slotDate === date)) return url;
    }
    return "";
  }

  function getDynamicRunImage(row){
    const fromApi = firstImageFromObject(row);
    if(fromApi && !isImageExpiredFromRow(row)) return fromApi;
    return getActiveSlotImage(row);
  }

  function hideRunImage(){
    const panel = document.getElementById("runImagePanel");
    const img = document.getElementById("runImage");
    const card = document.getElementById("runCard") || (panel ? panel.closest(".lkhhh-run-card") : null);
    if(panel){ panel.classList.remove("has-image"); panel.classList.add("is-hidden"); }
    if(card) card.classList.add("no-image");
    if(img) img.removeAttribute("src");
  }

  function showRunImage(imageUrl){
    const panel = document.getElementById("runImagePanel");
    const img = document.getElementById("runImage");
    const card = document.getElementById("runCard") || (panel ? panel.closest(".lkhhh-run-card") : null);
    if(!panel || !img) return;
    panel.classList.remove("is-hidden");
    panel.classList.add("has-image");
    if(card) card.classList.remove("no-image");
    img.alt = "Poster Hare LKHHH minggu ini";
    img.onerror = function(){ hideRunImage(); };
    img.src = imageUrl;
  }

  function renderRunImage(row){
    const imageUrl = getDynamicRunImage(row || {});
    if(!imageUrl){ hideRunImage(); return; }
    showRunImage(imageUrl);
  }

  function getRunLocation(row){
    return row.location || row.Location || row.lokasi || row.Lokasi || "New Posko LKHHH";
  }

  function getRunMap(row, location){
    const mapsUrl =
      row.googleMapsUrl ||
      row.googleMapsURL ||
      row.GoogleMapsURL ||
      row["Google Maps URL"] ||
      row.mapsUrl ||
      row.MapsUrl ||
      row.map ||
      row.Map ||
      "";

    if(mapsUrl) return mapsUrl;

    const loc = String(location || getRunLocation(row) || "").toLowerCase();
    if(loc.indexOf("posko") !== -1 || loc.indexOf("lkhhh") !== -1 || loc.indexOf("camp") !== -1){
      return DEFAULT_POSKO_MAP;
    }
    return "";
  }

  function renderRunLocation(location, mapUrl){
    const locSpan = document.getElementById("runLocation");
    const locLink = document.getElementById("runLocationLink");
    const mapBtn = document.getElementById("runMapBtn");
    const cleanLocation = location || "New Posko LKHHH";

    if(locSpan) locSpan.textContent = cleanLocation;

    if(locLink){
      if(mapUrl){
        locLink.href = mapUrl;
        locLink.style.display = "inline-flex";
        locLink.style.pointerEvents = "auto";
        locLink.classList.add("is-clickable");
        locLink.setAttribute("aria-label", "Buka lokasi " + cleanLocation + " di Google Maps");
        locLink.setAttribute("title", "Buka Google Maps");
      }else{
        locLink.removeAttribute("href");
        locLink.style.pointerEvents = "none";
        locLink.classList.remove("is-clickable");
        locLink.removeAttribute("title");
      }
    }else if(locSpan){
      if(mapUrl){
        locSpan.innerHTML = '<a class="lkhhh-inline-map-link" href="' + escapeAttr(mapUrl) + '" target="_blank" rel="noopener">' + escapeHtml(cleanLocation) + ' <span class="lkhhh-map-cta">Maps ↗</span></a>';
      }else{
        locSpan.textContent = cleanLocation;
      }
    }

    if(mapBtn){
      if(mapUrl){
        mapBtn.href = mapUrl;
        mapBtn.style.display = "inline-flex";
      }else{
        mapBtn.href = DEFAULT_CAMP_MAP;
        mapBtn.style.display = "none";
      }
    }
  }

  function renderUpcoming(data, currentRun){
  const grid = document.getElementById("upcomingGrid");
  if(!grid) return;

  const currentDate = currentRun && currentRun.date ? parseDate(currentRun.date) : null;
  const currentRunNo = currentRun && currentRun.run ? String(currentRun.run).trim() : "";

  const rows = data.map(function(row){
      return {row:row, date:parseDate(row.date)};
    })
    .filter(function(item){
      if(!item.date || !item.row.run || isHidden(item.row.status)) return false;

      /*
        Jadwal Hare Berikutnya tidak mulai dari Run Minggu Ini.
        Kalau current run ditemukan, tampilkan jadwal SETELAH tanggal current run.
      */
      if(currentDate){
        return item.date > currentDate;
      }

      if(currentRunNo && String(item.row.run || "").trim() === currentRunNo){
        return false;
      }

      return sameOrFuture(item.date);
    })
    .sort(function(a,b){ return a.date - b.date; })
    .slice(0,4);

  if(!rows.length){
    grid.innerHTML = '<div class="lkhhh-upcoming-card"><span class="lkhhh-upcoming-run">Segera</span><h3>Belum ada jadwal berikutnya</h3><p>Silakan cek kembali nanti.</p></div>';
    return;
  }

  grid.innerHTML = rows.map(function(item){
    const row = item.row;
    const hare = getRunHareLabel(row);
    const time = row.time || row.startTime || row.jam || "07.30 WIB";
    const location = getRunLocation(row);

    return '<div class="lkhhh-upcoming-card">' +
      '<span class="lkhhh-upcoming-run">#' + escapeHtml(row.run || "") + '</span>' +
      '<h3>' + escapeHtml(hare) + '</h3>' +
      '<p>' + escapeHtml(row.date || "") +
      '<br>⏰ ' + escapeHtml(time) +
      '<br>📍 ' + escapeHtml(location) +
      '</p></div>';
  }).join("");
}

  fetchFirestoreSchedule()
    .then(function(result){
      const best = result.current;
      renderUpcoming(result.schedule, best);

      if(!best){
        hideRunImage();
        renderRunLocation("New Posko LKHHH", DEFAULT_POSKO_MAP);
        return;
      }

      const hare = getRunHareLabel(best);
      const time = best.time || best.startTime || best.jam || "07.30 WIB";
      const location = getRunLocation(best);
      const map = getRunMap(best, location);

      setText("runDate", best.date || "");
      setText("runTime", time);
      renderRunLocation(location, map);
      setText("runNo", best.run || "----");
      setText("runHare", hare);
      renderRunImage(best);
    })
    .catch(function(){
      hideRunImage();
      setText("runDate", "Silakan refresh");
      setText("runTime", "07.30 WIB");
      renderRunLocation("New Posko LKHHH", DEFAULT_POSKO_MAP);
      setText("runNo", "----");
      setText("runHare", "Jadwal gagal dimuat");
    });
})();

(function(){
  const en = {
    navHome:"Home", navThisWeek:"This Week", navHareSchedule:"Hare Schedule", navCalendar:"Calendar", navDirection:"Direction", navAbout:"About",
    quickTitle:"Quick Access", quickThisWeek:"This Week's Run", quickHareSchedule:"Hare Schedule", quickComing:"Who's Coming",
    joinWa:"Join LKHHH Run Info Group", registerPanindo:"Register Panindo 2027", runTitle:"This Week's Run",
    runDesc:"Current run information, dynamic hare image, location, and attendance actions.", confirmAttendance:"Confirm Attendance", whoComing:"Who Is Coming?", viewMap:"View Map", hareSchedule:"Hare Schedule",
    calendarBadge:"📅 LKHHH RUN CALENDAR", calendarTitle:"Subscribe LKHHH Calendar", calendarDesc:"Add LKHHH run schedule to your phone calendar. The calendar follows Hare Schedule Master, including date, time, hare, and location.", calendarNote:"Choose Apple Calendar for direct subscription, or Google Calendar for a guided Add by URL popup.", calendarMiniNote:"Google Calendar should be added from desktop/laptop: <strong>Other calendars → + → From URL</strong>.",
    upcomingTitle:"Upcoming Hare", upcomingDesc:"Preview of the next runs from Hare Schedule Master.", loading:"Loading", pleaseWait:"Please wait", loadingSchedule:"Loading schedule...",
    directionBadge:"🧭 CAMP DIRECTION", campPhotoTitle:"LKHHH Camp Photo", campPhotoDesc:"If this image does not appear, open the image URL directly to check whether the Shopify file is public.", directionTitle:"Find Your Way to LKHHH Camp", directionDesc:"Follow the trail to Lancang Kuning Hash House Harriers camp. See you at the run. On On!", getDirection:"Get Direction",
    aboutTitle:"About LKHHH", aboutDesc1:"This is a short landing-page introduction. The full About LKHHH story should remain on the dedicated About page.", aboutDesc2:"Lancang Kuning Hash House Harriers is a Pekanbaru running community built around fun, fitness, friendship, and the spirit of On On.", readAbout:"Read Full About LKHHH",
    momentsTitle:"LKHHH Moments", momentsDesc:"Trail, camp, friendship, and weekly run memories.", galleryWeeklyTitle:"Weekly Run", galleryWeeklyDesc:"Regular run moments and trail memories.", galleryCampTitle:"Camp Life", galleryCampDesc:"LKHHH camp direction, gathering, and On On spirit.", galleryFriendTitle:"Friendship", galleryFriendDesc:"Fun, fitness, friendship, and community togetherness.",
    modalTitle:"Add to Google Calendar", modalDesc:"Google Calendar should be added from desktop/laptop.", modalHelp:"<strong>Step:</strong> Copy the calendar URL, then on desktop/laptop open Google Calendar → Other calendars → + → From URL → paste URL.", copyUrl:"Copy URL", openGoogle:"Open Google Calendar", selectUrl:"Select"
  };
  const st = {
    id:{copied:"✅ URL kalender sudah disalin. Sekarang klik Buka Google Calendar lalu paste.", selected:"URL dipilih. Tekan Command + C, atau tap Copy di mobile.", blocked:"⚠️ Browser memblokir salin otomatis. URL sudah dipilih. Tekan Command + C, atau tap Copy di mobile."},
    en:{copied:"✅ Calendar URL copied. Now click Open Google Calendar and paste it.", selected:"URL selected. Press Command + C, or tap Copy on mobile.", blocked:"⚠️ Browser blocked automatic copy. The URL is selected. Press Command + C, or tap Copy on mobile."}
  };

  function apply(lang){
    document.documentElement.setAttribute("lang", lang === "en" ? "en" : "id");
    document.querySelectorAll("#lkhhh-page [data-i18n]").forEach(function(el){
      if(!el.dataset.id) el.dataset.id = el.innerHTML;
      let v = lang === "en" ? en[el.dataset.i18n] : el.dataset.id;
      if(v) el.innerHTML = v;
    });
    document.querySelectorAll("#lkhhh-page .lkhhh-lang-btn").forEach(function(b){
      b.classList.toggle("is-active", b.dataset.lkhhhLang === lang);
    });
    window.LKHHH_CURRENT_LANG = lang;
    try{ localStorage.setItem("lkhhh_lang", lang); }catch(e){}
  }

  document.querySelectorAll("#lkhhh-page .lkhhh-lang-btn").forEach(function(b){
    b.addEventListener("click", function(){ apply(b.dataset.lkhhhLang || "id"); });
  });
  window.LKHHH_T_STATUS = function(k){
    const l = window.LKHHH_CURRENT_LANG || "id";
    return (st[l] && st[l][k]) || (st.id && st.id[k]) || "";
  };
  apply("id");
  window.LKHHH_SET_LANG = apply;
})();

/* Format current run Hare names after Google Sheet data loads */
(function(){
  function findHareElement(){
    return document.getElementById("runHare") ||
           document.querySelector(".lkhhh-run-hare") ||
           document.querySelector("[data-run-hare]");
  }

  function formatHareNames(){
    var el = findHareElement();
    if(!el) return;

    var raw = (el.textContent || "").trim();
    if(!raw) return;

    if(el.querySelector(".lkhhh-hare-name-chip")) return;

    var names = raw
      .replace(/\s*&\s*/g, ",")
      .split(",")
      .map(function(name){ return name.trim(); })
      .filter(Boolean);

    if(names.length <= 1){
      el.textContent = raw.toUpperCase();
      return;
    }

    el.innerHTML = names.map(function(name){
      return "<span class='lkhhh-hare-name-chip'>" + name.toUpperCase() + "</span>";
    }).join("");
  }

  function startObserver(){
    var el = findHareElement();
    if(!el) return;

    var observer = new MutationObserver(function(){
      setTimeout(formatHareNames, 50);
    });

    observer.observe(el, {childList:true, characterData:true, subtree:true});
    formatHareNames();
  }

  document.addEventListener("DOMContentLoaded", function(){
    formatHareNames();
    setTimeout(formatHareNames, 500);
    setTimeout(formatHareNames, 1200);
    setTimeout(formatHareNames, 2500);
    setTimeout(startObserver, 3000);
  });

  window.addEventListener("load", function(){
    formatHareNames();
    setTimeout(startObserver, 800);
  });
})();
